import React from 'react';
import styled, { css } from 'styled-components';
import { LFC } from '../../../Legacy';
import { Cell, Colors, Grid } from '../../../ui';
import { Seb } from '../../../ui/Seb';

const Frame = styled.div<{ clickable?: boolean }>`
    padding: 1.5rem;
    border-left: solid 5px ${Colors.negative};
    color: ${Colors.text};
    background: white;

    ${p => !p.clickable ? '' : css`
        cursor: pointer;
        &:hover {
            background: #fafafa;
        }
        &:active {
            background: #f5f5f5;
        }
    `};
`;

const BodyFrame = styled.div`
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
`;

export const AlertStyleError: LFC<{ clickable: boolean, delay: number }> = ({ clickable, children }) => {

    return <Frame clickable={clickable}>
        <Grid columns="min-content 1fr" columnGap="1">
            <Cell>
                <Seb color={Colors.negative} size="3" />
            </Cell>
            <Cell>
                <BodyFrame>
                    {children}
                </BodyFrame>
            </Cell>
        </Grid>
    </Frame>;
};
